"use client"

import { useState, useEffect } from "react"
import { CounterService } from "../services/counterService"

interface CounterStats {
  total: number
  fitness: number
  business: number
  success: number
  golf: number
  eating: number
  calm: number
  humble: number
  study: number
  stress: number
  relationship: number
  general: number
}

export const useCounterStats = () => {
  const [stats, setStats] = useState<CounterStats | null>(null) // Start with null instead of fallback
  const [isLoading, setIsLoading] = useState(true)
  const [hasLoaded, setHasLoaded] = useState(false)

  const fetchStats = async () => {
    try {
      const newStats = await CounterService.getAllStats()
      setStats(newStats)
      setHasLoaded(true)
    } catch (error) {
      console.error("Error fetching stats:", error)
      // Only set fallback if we haven't loaded real data yet
      if (!hasLoaded) {
        setStats({
          total: 10000,
          fitness: 2500,
          business: 2000,
          success: 2200,
          golf: 1800,
          eating: 1700,
          calm: 1500,
          humble: 1200,
          study: 1600,
          stress: 1300,
          relationship: 1400,
          general: 1500,
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchStats()

    // Refresh stats every 30 seconds
    const interval = setInterval(fetchStats, 30000)

    return () => clearInterval(interval)
  }, [])

  return {
    stats,
    isLoading,
    hasLoaded, // Make sure this is included in the return
    refreshStats: fetchStats,
  }
}
